import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';

import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, Mascaras, formataCPF, formataCNPJ } from './../app.config';

import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';

@Component({
  selector: 'ntc-assinantes',
  templateUrl: './assinantes.component.html',
  styleUrls: ['./assinantes.component.css']
})
export class AssinantesComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  assinantes: any = {};
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridAssinante = null;
  editOptionsGridAssinante = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Assinante',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private router: Router
  ) {
    this.assinantes = new CustomStore({
      remove: function (key) {
        return http.delete(`${NTECH_API}/assinantes/${encodeURIComponent(key.Id)}`).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/assinantes/`)
            .toPromise()
            .then(response => {
                const json = response.json();
                return json;
            })
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onEditingStart(e) {
    this.router.navigate([`/assinante/${e.data.Id}`]);
  }

  onInitNewRow(e) {
    this.router.navigate(['/assinante']);
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  textoSumario(e) {
    return 'Registros: ' + e.value;
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  montaColunasGrid() {
    this.colunasGridAssinante = [
      {
        dataField: 'Id',
        dataType: 'string',
        width: '70',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'Pessoa.Nome',
        dataType: 'string',
        caption: 'Nome'
      },
      {
        dataField: 'Pessoa.Cpf',
        dataType: 'string',
        caption: 'CPF',
        editorOptions: { mask: Mascaras.Cpf },
        customizeText: formataCPF
      },
      {
        dataField: 'Pessoa.Cnpj',
        dataType: 'string',
        caption: 'CNPJ',
        editorOptions: { mask: Mascaras.Cnpj },
        customizeText: formataCNPJ
      }
    ];
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    this.montaColunasGrid();
  }

}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes.component.ts